<!-- <div *ngIf="userToken==='admin'"> -->

<div *ngIf="loaded == 1" class="cw">

    <h6 *ngIf="id === null" class="mgt40 ft500">Agregar empresa cliente</h6>
    <h6 *ngIf="id" class="mgt40 ft500">Editar empresa cliente</h6>
    <hr>

    {{usuario.uid}}
    <!-- FORMULARIO PARA AGREGAR / EDITAR DOCUMENTO DE LA COLECCIÓN -->
    <form>
        <div>
            <label>Nombre de la empresa</label>
            <input type="text" [(ngModel)]="empresa.nombre" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Resumen</label>
            <input type="text" [(ngModel)]="empresa.resumen" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Descripcion</label>
            <textarea class="fw" maxlength="5000" [(ngModel)]="empresa.descripcion"
                [ngModelOptions]="{standalone: true}">
            </textarea>
        </div>
        <div>
            <label>Sitio Web</label>
            <input type="text" [(ngModel)]="empresa.sitioWeb" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label>Enlace Linkedin</label>
            <input type="text" [(ngModel)]="empresa.enlaceLinkedin" [ngModelOptions]="{standalone: true}" class="fw">
        </div>
        <div>
            <label> Foto de Empresa </label>
            <input type="file" class="fw" id="file" (change)="cargarFoto($event, 'foto')" name="image"
                autocomplete="off" />
        </div>
        <div class="containerImg">
            <img *ngIf="empresa.foto" [src]="empresa.foto" alt="imagenEmpresa" class="fw fh">
        </div>
        <div>
            <label>¿Publicado?</label>
            <select [(ngModel)]="empresa.publicado" [ngModelOptions]="{standalone: true}" class="fw">
                <option [ngValue]="'publicado'">Publicado</option>
                <option [ngValue]="'baja'">Baja</option>
                <option [ngValue]="'borrador'">Borrador</option>
            </select>
        </div>
        <br>
        <button type="button" class="darkButton" (click)="guardarEmpresa()">Guardar</button>
    </form>


    <!-- ELIMINAR DOCUMENTO DE LA COLECCIÓN -->
    <div *ngIf="id" class="mgt30">
        <a class="blueLink" *ngIf="confirmar===0" (click)="confirmar=1">Eliminar</a>
        <div *ngIf="confirmar===1" fxLayout="column">
            <p>Escriba la palabra CONFIRMAR para eliminar</p>
            <div>
                <input type="text" [(ngModel)]=textoConfirmacion class="mgr10">
                <button *ngIf="textoConfirmacion==='CONFIRMAR'" (click)="eliminarEmpresa()"
                    class="redButton">Eliminar</button>
                <button *ngIf="textoConfirmacion!=='CONFIRMAR'" class="cursorDefault">Eliminar</button>
            </div>
            <a class="blueLink" (click)="confirmar=0" class="mgt10">Cancelar</a>
        </div>
    </div>
</div>


<div *ngIf="loaded == 0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>

<!-- </div> -->

<!-- <div *ngIf="userToken==='visitante'">
        <permiso-insuficiente></permiso-insuficiente>
    </div> -->